import {
  AutocompleteArrayInput,
  BooleanInput,
  Edit,
  email,
  ListButton,
  number,
  NumberInput,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { SimpleBoxLoader } from "@/components/loader";
import { MODULE_NAMES } from "@/constants";
import { ReferenceAutoCompleteArrayInput } from "@/inputs/ReferenceAutoCompleteArrayInput";
import { useRadiusVpnServers } from "@/modules/radiusVpnServers";

import { ClientAppCopyVpn } from "./ClientAppCopyVpn";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
  </TopToolbar>
);

export const ClientAppEdit = () => {
  const {
    data: { radiusVpnServersChoices } = {},
    isLoading: isRadiusVpnServersLoading,
  } = useRadiusVpnServers();

  if (isRadiusVpnServersLoading) {
    return <SimpleBoxLoader />;
  }
  return (
    <Edit
      actions={<EditActions />}
      title="Client App"
      mutationMode="pessimistic"
    >
      <SimpleForm toolbar={<EditToolbar />}>
        <TextInput source="title" validate={required()} />
        <TextInput source="email" validate={[required(), email()]} />
        <TextInput source="secret" />
        <NumberInput
          label="Device Type Id"
          source="deviceTypeId"
          validate={[number(), required()]}
        />
        <BooleanInput source="isCampaignDriven" label="Is Campaign Driven" />
        <AutocompleteArrayInput
          source="vpnServers"
          label="VPN Servers"
          choices={radiusVpnServersChoices || []}
          disableCloseOnSelect
        />
        <ClientAppCopyVpn />
        <ReferenceAutoCompleteArrayInput
          module={MODULE_NAMES.LANDINGS}
          source="allowedLandings"
          optionText="title"
          optionValue="@id"
          disableCloseOnSelect
        />
        <TextInput source="diKey" label="Di Key" />
        <TextInput source="domain" validate={required()} />
      </SimpleForm>
    </Edit>
  );
};
